export const getDateNow = () => {
  return new Date();
}